import AddIcon from './ic-add.webp';
import AdultIcon from './ic-adult.webp';
import AirAsiaIcon from './ic-air-asia.webp';
import BaggageIcon from './ic-baggage.webp';
import bgIcon from './ic-bg.webp';
import BookmarkIcon from './ic-bookmark.webp';
import CalendarIcon from './ic-calendar.webp';
import CartIcon from './ic-cart.webp';
import CathayPacificIcon from './ic-cathay-pacific.webp';
import EditIcon from './ic-edit.webp';
import EmiratesIcon from './ic-emirates.webp';
import EnterIcon from './ic-enter.webp';
import FreeIcon from './ic-free.webp';
import HomeIcon from './ic-home-icon.webp';
import LocationIcon from './ic-location.webp';
import MinusMarkIcon from './ic-minus-mark.webp';
import MmtLogoIcon from './ic-mmt-logo.webp';
import MmtSpecialTagIcon from './ic-mmt-special-tag.webp';
import moreBaggageIcon from './ic-more-baggage.webp';
import PaxIcon from './ic-pax.webp';
import PlaneIcon from './ic-plane.webp';
import PreferencesIcon from './ic-preferences.webp';
import SelectedTickIcon from './ic-selected-tick.webp';
import SingaporeAirlinesIcon from './ic-singapore-airlines.webp';
import TickMarkIcon from './ic-tick-mark.webp';
import TickIcon from './ic-tick.webp';
import VietjetAirIcon from './ic-vietjet-air.webp';
import VietjetAirlinesIcon from './ic-vietjet-airlines.webp';
import VoiceIcon from './ic-voice.webp';
import WelcomeImageIcon from './ic-welcome-image.webp';
import BackArrowIcon from './ic-back-arrow.webp';
import RightArrowWhiteIcon from './ic-right-arrow-white.webp';
import WarningIcon from './ic-warning.webp';
import OnboardingBgIcon from './ic-onboarding-bg.svg';
import TripPreferenceBgIcon from './ic-trip-preference-bg.svg';
import WeatherIcon from './ic-weather.webp';
import DownArrowIcon from './ic-arrow-down.webp';
import PolygonShapeIcon from './ic-polygon-shape.webp';
import CloudShapeIcon from './ic-cloud-shape.webp';
import StarShapeIcon from './ic-star-shape.webp';
import WavyShapeIcon from './ic-wavy-shape.webp';
import EarthCustomIcon from './ic-earth-custom.webp';
import TooltipImageIcon from './ic-tooltip-img.webp';
import MmtAiAvatarIcon from './ic-mmt-ai-avatar.webp';
import FlightListingThumbnailIcon from './ic-flight-listng-thumbnail.webp';
import FlightIcon from './ic-flight.webp';
import RightArrowBlueIcon from './ic-right-arrow-blue.webp';
import HotelIcon from './ic-hotel-icon.webp';
import GogglesIcon from './ic-goggles-icon.webp';
import HotelMapIcon from './ic-hotel-map.webp';
import CouponIcon from './ic-coupon.webp';
import DeleteIcon from './ic-delete.webp';
import GSTIcon from './ic-gst.webp';
import ArrowBlueIcon from './ic-arrow-blue.webp';
import ArrowWhiteIcon from './ic-arrow-white.webp';
import CheckIcon from './ic-check.webp';
import PremiumClass from './ic-premium-economy.webp';
import BusinessClass from './ic-business-class.webp';
import FirstClass from './ic-first-class.webp';
import SuccessTickIcon from './ic-success-tick.webp';
import DownloadIcon from './ic-download.webp';
import WebCheckinIcon from './ic-webcheckin.webp';
import TravellerIcon from './ic-traveller.webp';
import CabinBagIcon from './ic-cabinbag.webp';
import FailedIcon from './ic-failed.webp';
import PendingIcon from './ic-pending.webp';
import LocationIconActive from './ic-location-active.webp';
import LocationIconDisabled from './ic-location-disabled.webp';
import DateIconActive from './ic-date-active.webp';
import DateIconDisabled from './ic-date-disabled.webp';
import GuestIconActive from './ic-adult-active.webp';
import GuestIconDisabled from './ic-adult-disabled.webp';
import PreferencesIconActive from './ic-preferences-active.webp';
import PreferencesIconDisabled from './ic-preferences-disabled.webp';
import RoomIcon from './ic-room.webp';
import GuestIcon from './ic-guest.webp';
import PetIcon from './ic-pet.webp';
import ChildrenIcon from './ic-child.webp';
import ArrowForwardIcon from './ic-arrow-forward.webp';
import ImageGroupIcon from './ic-image-group.webp';
import MyraAiBetaIcon from './ic-myra-ai-beta.webp';
import MyraAiIcon from './ic-myra.webp';
import MyLoginIcon from './ic-my-login.webp';
import LocationBlackIcon from './ic-location-black.webp';
import ImagePreviewIcon from './ic-image-preview.webp';

export const icons = {
  AddIcon,
  AdultIcon,
  AirAsiaIcon,
  BaggageIcon,
  bgIcon,
  BookmarkIcon,
  CalendarIcon,
  CartIcon,
  CathayPacificIcon,
  EditIcon,
  EmiratesIcon,
  EnterIcon,
  FreeIcon,
  HomeIcon,
  LocationIcon,
  MinusMarkIcon,
  MmtLogoIcon,
  MmtSpecialTagIcon,
  moreBaggageIcon,
  PaxIcon,
  PlaneIcon,
  PreferencesIcon,
  SelectedTickIcon,
  SingaporeAirlinesIcon,
  TickMarkIcon,
  TickIcon,
  VietjetAirIcon,
  VietjetAirlinesIcon,
  VoiceIcon,
  WelcomeImageIcon,
  BackArrowIcon,
  RightArrowWhiteIcon,
  WarningIcon,
  OnboardingBgIcon,
  TripPreferenceBgIcon,
  WeatherIcon,
  DownArrowIcon,
  PolygonShapeIcon,
  CloudShapeIcon,
  StarShapeIcon,
  WavyShapeIcon,
  EarthCustomIcon,
  TooltipImageIcon,
  MmtAiAvatarIcon,
  FlightListingThumbnailIcon,
  FlightIcon,
  RightArrowBlueIcon,
  HotelIcon,
  GogglesIcon,
  HotelMapIcon,
  CouponIcon,
  DeleteIcon,
  GSTIcon,
  ArrowBlueIcon,
  ArrowWhiteIcon,
  CheckIcon,
  PremiumClass,
  BusinessClass,
  FirstClass,
  SuccessTickIcon,
  DownloadIcon,
  WebCheckinIcon,
  TravellerIcon,
  CabinBagIcon,
  FailedIcon,
  PendingIcon,
  LocationIconActive,
  LocationIconDisabled,
  DateIconActive,
  DateIconDisabled,
  GuestIconActive,
  GuestIconDisabled,
  PreferencesIconActive,
  PreferencesIconDisabled,
  RoomIcon,
  GuestIcon,
  PetIcon,
  ChildrenIcon,
  ArrowForwardIcon,
  ImageGroupIcon,
  MyraAiBetaIcon,
  MyraAiIcon,
  MyLoginIcon,
  LocationBlackIcon,
  ImagePreviewIcon,
};
